import type {
  HookFormChanged_Type,
  HookFormValidate_Type,
} from "../../../../_ovlclient/src/global/hooks"
import { SYSAction } from "../../../src"
import { DialogCurrentState } from "../../../src/library/dialog/dialogapi"

import {
  FieldSetFocus,
  FieldSetForceChange,
  FieldSetVal,
  FieldVal,
} from "../../../src/library/forms/fieldapi"

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (
  value,
  { global }
) => {
  if (value.changedField.fieldKey.toString().startsWith("TOTPDigit")) {
    let totpCode = ""
    for (let i = 0; i < 6; i++) {
      let fkey = `TOTPDigit${i + 1}`
      totpCode = `${totpCode}${FieldVal(value.formState.fields[fkey])}`
    }
    if (totpCode.length === 6 && /^\d+$/.test(totpCode)) {
      let actions = global.getActions()
      let state = global.getState()
      let dialogState =
        state.ovl.dialogs.SYSTOTP.instance[value.formState.formId]
      //@ts-ignore
      await actions.app.features.SYSTOTP.actions.Verify({
        formState: value.formState,
        dialogState,
        code: totpCode,
        requestKey: dialogState.data.RequestKey,
      })
    }
  }
}

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (value) => {
  let field = value.field
  let fieldKey = field.fieldKey
  if (fieldKey.startsWith("TOTPDigit")) {
    let currentIdx = parseInt(fieldKey.replace("TOTPDigit", "")) - 1
    if (value.newValue != null) {
      let val = value.newValue.toString().trim()
      if (val.length === 6 && /^\d+$/.test(val)) {
        // current field we need to adjust using corrected value -> ovl won't do anything if a field in change (validated, changed) is set again
        await value.setCorrectedValue(val[currentIdx], true)
        for (let i = 0; i < 6; i++) {
          if (i === currentIdx) {
            continue
          }
          await FieldSetVal(
            value.formState.fields[`TOTPDigit${i + 1}`],
            val[i],
            { ignoreValueChanged: true }
          )
        }
        FieldSetForceChange(value.field)
      } else {
        const regex = /^[0-9]$/
        if (!regex.test(val)) {
          value.setCorrectedValue(null)
        } else {
          if (currentIdx < 5) {
            FieldSetFocus(value.formState.fields[`TOTPDigit${currentIdx + 2}`])
          } else {
            FieldSetFocus(value.formState.fields[`TOTPDigit1`])
          }
        }
      }
    }
    if (value.validatorUse("Mandatory")) {
      value.validatorUse("MinLength", { val: 1 })
    }
  }
}

export let hooks = { HookFormValidate, HookFormChanged }
